import styled from "styled-components";
import { Input, Button } from "reactstrap";

export const FormWrapperForm = styled.div`
  h2 {
    color: #007dc3;
    font-family: "Raleway", sans-serif;
    font-weight: 700;
    margin: 30px 0;
    font-size: 24px;
  }

  label {
    font-weight: 600;
    margin: 0;
    text-align: left;
    display: block;
  }

  /* Adiciona a rolagem horizontal na tabela */
  .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* Melhor para dispositivos móveis */
  }

  .table th,
  .table td {
    white-space: nowrap; /* Evita que o conteúdo das células quebre */
  }

  /* Ajuste de largura para pequenas telas */
  @media (max-width: 768px) {
    .table th,
    .table td {
      font-size: 12px;
      padding: 8px;
    }
  }

  button[type="submit"] {
    background: linear-gradient(
      268.2deg,
      #006eb0 -5.28%,
      #00afef 100%,
      #007dc3 100%
    );
    border-radius: 40px;
    border: none;
    padding: 10px 50px;
    margin-top: 20px;
    font-size: 23px;
    text-align: left;
  }

  button:focus {
    outline: none;
  }

  @media (max-width: 990px) {
    button[type="submit"] {
      width: 100%;
      text-align: center;
      font-size: 18px;
    }
  }
`;

export const InputView = styled(Input)`
  ::placeholder {
    color: #ccc;
  }
`;

export const WrapperEmailList = styled.div`
  display: block;
  border-radius: 0.25rem;
  padding: 20px 10px;
  text-align: left;
  background: #f5f5f5;

  .badge {
    margin: 0 2px;
  }
`;
export const Suport = styled.a`
  position: fixed;
  top: 80%;
  left: -70px; /* escondido para fora da tela */
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 16px;

  background: #1f2937;
  color: #fff;

  padding: 12px 16px;
  border-radius: 0 8px 8px 0; /* invertido */

  font-size: 14px;
  font-weight: 500;
  text-decoration: none;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition:
    left 0.3s ease,
    background 0.2s;

  &:hover {
    left: 0; /* desliza para dentro */
    color: #fff;
    text-decoration: none;
    background: #111827;
  }

  svg {
    font-size: 23px;
  }
`;
export const ButtonRedFlag = styled(Button)`
  background: linear-gradient(
    268.2deg,
    #ff7f32 -5.28%,
    #ff8c00 100%,
    #ff6600 100%
  );
  border-radius: 5px;
  border: none;
  padding: 5px 30px;
  font-size: 16px;
  text-align: left;

  &:focus {
    outline: none;
  }

  /* Responsividade para telas pequenas */
  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    font-size: 16px;
    padding: 10px 20px;
  }

  /* Em telas médias e grandes */
  @media (min-width: 769px) {
    width: auto;
    padding: 10px 30px;
    font-size: 18px;
  }
`;

export const ButtonNext = styled(Button)`
  width: 25%;
  padding: 10px 25px;
  border-radius: 30px;
  border: none;
  font-size: 18px;
  font-weight: 600; /* Deixa a fonte mais grossa (semi-negrito) */
  background-color: #25d366; /* Cor verde do WhatsApp */
  margin-top: 20px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white; /* Cor do texto branca */
  cursor: pointer; /* Cursor de mão ao passar o mouse */

  /* Alterando a cor ao passar o cursor */
  &:hover {
    color: black; /* Muda a cor do texto para preto */
    text-decoration: none; /* Remover sublinhado, se houver */
  }

  /* Ajuste no tamanho do botão para telas menores */
  @media (max-width: 768px) {
    width: 80%; /* Ocupa 80% da largura */
    padding: 12px 20px; /* Padding reduzido */
    font-size: 16px; /* Tamanho da fonte menor */
  }
`;

export const ButtonOrder = styled(Button)`
  color: white;
  padding: 8px 20px;
  border-radius: 25px;
  border: none;
  font-family: "Raleway", sans-serif;
  font-weight: 700;
  font-size: 18px;
  background: linear-gradient(
    268.2deg,
    #00476e -5.28%,
    #0060a4 100%,
    #004f8a 100%
  );
  margin-right: 1px;
  margin-top: 10px;
  white-space: normal; /* Permite quebra de linha no texto */
  line-height: 1.4; /* Espaço entre as linhas do texto */

  /* Garantir que o botão tenha altura mínima */
  min-height: 40px; /* Define altura mínima */

  /* Ajuste de padding para dar mais espaço conforme necessário */
  padding: 10px 20px;

  @media (max-width: 768px) {
    width: 100%; /* O botão vai ocupar 100% da largura da tela em dispositivos menores */
    font-size: 16px;
    min-height: 50px; /* Altura mínima maior em telas menores */
    padding: 12px 20px; /* Aumentar o padding para melhorar a aparência */
  }

  @media (max-width: 380px) {
    font-size: 15px; /* Ajustar ainda mais o tamanho da fonte em telas pequenas */
    min-height: 60px; /* Garantir que o botão fique suficientemente alto em telas muito pequenas */
    padding: 12px 20px;
  }
`;

export const ButtonShow = styled(Button)`
  color: white;
  padding: 8px 20px;
  border-radius: 25px;
  border: none;
  font-family: "Raleway", sans-serif;
  font-weight: 700;
  font-size: 18px;
  background: linear-gradient(
    268.2deg,
    #003d61 -5.28%,
    #005594 100%,
    #004678 100%
  );
  margin-right: 1px;
  margin-top: 10px;
  white-space: normal; /* Permite quebra de linha no texto */
  line-height: 1.4; /* Ajusta o espaçamento entre as linhas */

  min-height: 50px; /* Define a altura mínima */

  padding: 10px 20px; /* Ajuste de padding para garantir mais espaço */

  /* Ajustes para telas menores */
  @media (max-width: 768px) {
    width: 100%; /* Faz o botão ocupar toda a largura em telas menores */
    font-size: 16px;
    min-height: 60px; /* Aumenta a altura mínima em telas menores */
    padding: 12px 20px; /* Ajusta o padding para melhor aparência */
  }

  @media (max-width: 380px) {
    font-size: 15px; /* Ajusta a fonte para telas pequenas */
    min-height: 70px; /* Aumenta a altura mínima ainda mais */
    padding: 12px 20px;
  }
`;

export const ButtonOther = styled(Button)`
  color: white;
  padding: 8px 20px;
  border-radius: 35px;
  border: none;
  font-family: "Raleway", sans-serif;
  font-weight: 700;
  font-size: 18px;
  height: 50px;
  background: linear-gradient(
    268.2deg,
    #002f59 -5.28%,
    #00488a 100%,
    #003f74 100%
  );

  margin-top: 10px;

  @media (max-width: 990px) {
    font-size: 16px; /* Ajusta o tamanho da fonte */
    padding: 10px 15px; /* Ajusta o padding */
    margin-right: 10px;
    height: 80px;
    width: 100%; /* Faz o botão ocupar toda a largura disponível */
    max-width: 350px; /* Limita a largura máxima */
  }
  @media (max-width: 400px) {
    font-size: 16px; /* Ajusta o tamanho da fonte */
    padding: 10px 15px; /* Ajusta o padding */
    margin-right: 10px;

    width: 100%; /* Faz o botão ocupar toda a largura disponível */
    max-width: 350px; /* Limita a largura máxima */
  }
`;

export const LeftAlignedTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  margin-top: 30px;
`;

export const ButtonUpdate = styled(Button)`
  color: white;
  padding: 8px 20px;
  border-radius: 5px;
  border: none;
  font-family: "Raleway", sans-serif;
  font-weight: 700;
  font-size: 18px;
  background: linear-gradient(
    268.2deg,
    #003d61 -5.28%,
    #005594 100%,
    #004678 100%
  );
  margin-right: 1px;
  margin-top: 10px;
  white-space: normal; /* Permite quebra de linha no texto */
  line-height: 1.4; /* Ajusta o espaçamento entre as linhas */

  min-height: 50px; /* Define a altura mínima */

  padding: 10px 20px; /* Ajuste de padding para garantir mais espaço */

  /* Ajustes para telas menores */
  @media (max-width: 768px) {
    width: 100%; /* Faz o botão ocupar toda a largura em telas menores */
    font-size: 16px;
    min-height: 60px; /* Aumenta a altura mínima em telas menores */
    padding: 12px 20px; /* Ajusta o padding para melhor aparência */
  }

  @media (max-width: 380px) {
    font-size: 15px; /* Ajusta a fonte para telas pequenas */
    min-height: 70px; /* Aumenta a altura mínima ainda mais */
    padding: 12px 20px;
  }
`;

export const ButtonInstruction = styled(Button)`
  color: white;

  border-radius: 15px;
  border: none;
  font-family: "Raleway", sans-serif;
  font-weight: 700;
  font-size: 18px;
  background: linear-gradient(
    268.2deg,
    rgb(2, 73, 114) -5.28%,
    rgb(4, 98, 170) 100%,
    rgb(1, 54, 92) 100%
  );
  margin-right: 1px;
  margin-top: 10px;
  white-space: normal; /* Permite quebra de linha no texto */
  line-height: 1.4; /* Ajusta o espaçamento entre as linhas */

  min-height: 50px; /* Define a altura mínima */

  padding: 10px 20px; /* Ajuste de padding para garantir mais espaço */

  /* Ajustes para telas menores */
  @media (max-width: 768px) {
    width: 100%; /* Faz o botão ocupar toda a largura em telas menores */
    font-size: 16px;
    min-height: 60px; /* Aumenta a altura mínima em telas menores */
    padding: 12px 20px; /* Ajusta o padding para melhor aparência */
  }

  @media (max-width: 380px) {
    font-size: 15px; /* Ajusta a fonte para telas pequenas */
    min-height: 70px; /* Aumenta a altura mínima ainda mais */
    padding: 12px 20px;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #222;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }

  &:active {
    background-color: rgba(0, 0, 0, 0.3);
  }

  svg {
    font-size: 23px;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  flex-wrap: wrap; /* Permite que as divs se ajustem em telas pequenas */

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Section = styled.div`
  flex: 1;
  min-width: 250px; /* Tamanho mínimo para cada seção */
  padding: 15px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);

  h3 {
    margin-bottom: 10px;
    color: #333;
  }

  p {
    color: #666;
    font-size: 17px;
    line-height: 1.5;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;
